import React from 'react';

import VideoPlaylistInner from './video_playlist_inner.jsx';
import VideoPlaylistItem from './video_playlist_item_container.jsx';

const VideoPlaylist = ({
  subpageId,
  contentItems,
  onSelectVideoClick,
  onSelectContentClick,
  selectedContentItem,
  ...props
})=> {

  if (contentItems.length === 0) {
    return null;
  }

  return (
    <VideoPlaylistInner
      contentItems={contentItems}
      selectedContentItem={selectedContentItem}
      {...props}
    >
      {
        contentItems.map((item, idx)=> (
          <VideoPlaylistItem 
            key={item.id}
            playlistIdx={idx}
            uuid={item.uuid}
            subpageId={subpageId}
            isSelected={selectedContentItem.uuid === item.uuid}
            title={item.title} 
            htmlCaption={item.renderedCaption} 
            onClick={()=> {
              onSelectContentClick(item);
            }}
            onSelectContentClick={()=> {
              onSelectContentClick(item);
            }}
            onSelectVideoClick={()=> {
              onSelectVideoClick(item);
            }}
          />
        ))
      }
    </VideoPlaylistInner>
  );
};

export default VideoPlaylist;
